import React from 'react';
import { ControlInfo } from 'ia-react-core/~/interfaces/ControlInfo';
import { ControlState } from 'ia-react-core/~/interfaces/ControlState';
import { DeepPartial } from 'ia-react-core/~/interfaces/DeepPartial';
import { FormState } from 'ia-react-core/~/interfaces/FormState';
import { NestedFormInfo } from 'ia-react-core/~/interfaces/NestedFormInfo';
import { FormRegistration } from '../Form/withFormMethods';
export interface FormContextProps<Values> {
  formScope: string[];
  ancestorFormId?: number;
  parentFormId?: number;
  initialValues?: DeepPartial<Values>;
  parentDefaultValues?: object;
  valuesDst?: string;
  formReducerKey?: string;
  ancestorFormReducerKey?: string;
  ancestorValuesDst?: string;
  formReducerScope?: string[];
  ancestorFormReducerScope?: string[];
  disabled?: boolean;
  readOnly?: boolean;
  textOnly?: boolean;
  hideErrorMessages?: boolean;
  allowInvalid?: boolean;
  nestedControlInfos?: ControlInfo[];
  nestedFormInfos?: NestedFormInfo<Values>[];
  isolatedSubForm?: boolean;
  hideHoistedAnchor?: boolean;
  ancestorCommitFormValues?: (values: DeepPartial<Values>, options: {
    formValuePath?: string; path?: string; shouldMerge?: boolean; mergeBlacklist?: object[]; commits?: (() => void); }) => void;
  ancestorCommitFormState?: (formStateChanges: DeepPartial<FormState>, options?: { formStatePath?: string }) => void;
  setControlValue?: (name: string, value: unknown, callback?: () => void) => void;
  setControlState?: (name: string, state: ControlState) => void;
  registerControl?: (controlInfo: ControlInfo) => void;
  unregisterControl?: (options: ControlInfo) => void;
  unregisterForm?: (formInfo: { formId: number; name: string }) => void;
  registerForm?: (formInfo: NestedFormInfo<Values>) => void;
  watchRegistrations?: (callback: FormRegistration<Values>) => void;
}

const FormContext = React.createContext<FormContextProps<any>>({ formScope: [] });

export default FormContext;
